import { Controller } from 'stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['icon']

  connect() {
    // https://leastbad.com/stimulus-power-move
    // allow hides controllers to be easily accessed
    this.element[this.identifier] = this;
  }

  hide() {
    const controller = this;

    $.ajax({
      url: controller.data.get('url'),
      type: 'POST',
      dataType: 'text',
      success: (response) => {
        document.body['audio-player'].playNext();
        document.body['audio-player'].refreshHideBtns();
      },
      error: (response) => {
        console.log('HIDE ERROR:', response.responseText);

        const $modal = $('#modal-holder');
        $modal.html(response.responseText);
        $modal.find('.modal').modal('show');
      },
    });
  }

  refresh() {
    const controller = this;

    $.ajax({
      url: '/hide',
      type: 'GET',
      dataType: 'text',
      success: (response) => {
        $(controller.iconTarget).replaceWith(response);
      },
      error: (response) => {
        console.log('failed to refresh hide controller: ' + controller)
      },
    });
  }
}
